<svg
  *ngIf="data && data.length; else zeroState"
  xmlns="http://www.w3.org/2000/svg"
  (clientSize)="svgSize = $event"
>
  <ng-container *ngIf="getXScale() && getYScale()">
    <g *ngFor="let tick of getXTicks()">
      <rect
        class="tick"
        [attr.x]="getXScale()(tick)"
        y="0"
        width="1"
        [attr.height]="minZero(getYScale()(0))"
      ></rect>
      <text
        class="x-tick-label"
        [attr.x]="getXScale()(tick)"
        [attr.y]="getYScale()(0)"
        dy="16"
      >
        {{ binFormatter(tick) }}
      </text>
    </g>
    <g *ngFor="let tick of getYTicks()">
      <rect
        class="tick"
        x="0"
        [attr.y]="getYScale()(tick)"
        width="100%"
        height="1"
      ></rect>
      <text class="y-tick-label" x="0" [attr.y]="getYScale()(tick)" dy="-4">
        {{ valueFormatter(tick) }}
      </text>
    </g>
    <rect
      *ngIf="getHighlightRect() as rect"
      class="highlight"
      [attr.x]="rect.x"
      [attr.y]="rect.y"
      [attr.width]="minZero(rect.width)"
      [attr.height]="minZero(rect.height)"
    >
      <title *ngIf="highlightRangeTooltip">{{ highlightRangeTooltip }}</title>
    </rect>
    <g *ngFor="let bar of getBars()">
      <rect
        class="bar"
        [attr.x]="bar.x"
        [attr.y]="bar.y"
        [attr.width]="minZero(bar.w)"
        [attr.height]="minZero(bar.h)"
      >
        <title>
          {{ binFormatter(bar.binLowerBound) }} -
          {{ binFormatter(bar.binUpperBound) }}:
          {{ valueFormatter(bar.value) }}
        </title>
      </rect>
    </g>
  </ng-container>
</svg>

<ng-template #zeroState>
  <div class="zero-state">No data to display.</div>
</ng-template>
